import {
    ADD_CONCEPT_FAILURE,
    ADD_CONCEPT_REQUEST,
    ADD_CONCEPT_SUCCESS,
    AddConceptFailureAction,
    AddConceptRequestAction,
    AddConceptSuccessAction,
    CONCEPTS_FETCH_FAILURE,
    CONCEPTS_FETCH_REQUEST,
    CONCEPTS_FETCH_SUCCESS,
    ConceptsFetchFailureAction,
    ConceptsFetchRequestAction,
    ConceptsFetchSuccessAction,
    REMOVE_CONCEPT_FAILURE,
    REMOVE_CONCEPT_REQUEST,
    REMOVE_CONCEPT_SUCCESS,
    RemoveConceptFailureAction,
    RemoveConceptRequestAction,
    RemoveConceptSuccessAction,
    UPDATE_CONCEPT_POSITION_SUCCESS,
    UpdateConceptsPositionSuccessAction,
} from 'mk2/apps/adminclub/containers/ConceptTaggingWidget/ConceptTaggingWidget.actions';
import { tupdate } from 'mk2/helpers/types';
import { LoadingState } from 'mk2/reducers/loadingState';
import { Reducer } from 'redux';

export interface ConceptState {
    conceptIds: number[];
    articleConceptMapping: {[id: number]: string};
    loadingState: LoadingState;
    renderBlankInit: boolean;
    errorMessage: string;
}

export const initialConceptState: ConceptState = {
    conceptIds: [],
    articleConceptMapping: {},
    loadingState: LoadingState.INIT,
    renderBlankInit: true,
    errorMessage: null,
};

declare type ConceptsReducerAction =
    | RemoveConceptSuccessAction
    | UpdateConceptsPositionSuccessAction
    | AddConceptSuccessAction;

const conceptReducer: Reducer<ConceptState> = (state = initialConceptState, action: ConceptsReducerAction) => {
    switch (action.type) {
        case ADD_CONCEPT_SUCCESS:
            return tupdate(state, {
                conceptIds: [...state.conceptIds, action.response.result.concept],
                articleConceptMapping: {...state.articleConceptMapping, ...action.response.result.articleConceptMapping},
            });

        case REMOVE_CONCEPT_SUCCESS:
            return tupdate(state, {
                conceptIds: state.conceptIds.filter((id) => (id !== action.conceptId)),
            });

        case UPDATE_CONCEPT_POSITION_SUCCESS:
            return tupdate(state, {
                conceptIds: action.response.result.concepts,
            });

        default:
            return state;
    }
};

type ConceptFetchActions = ConceptsFetchRequestAction
    | ConceptsFetchSuccessAction
    | ConceptsFetchFailureAction;

const conceptFetchReducer = (state = initialConceptState, key: string, action: ConceptFetchActions) => {
    switch (action.type) {
        case CONCEPTS_FETCH_REQUEST:
            return {
                ...state,
                loadingState: LoadingState.LOADING,
            };
        case CONCEPTS_FETCH_FAILURE:
            return {
                ...state,
                error: action.error,
                loadingState: LoadingState.FAILURE,
            };
        case CONCEPTS_FETCH_SUCCESS:
            return {
                ...state,
                conceptIds: action.items[key].conceptIds,
                articleConceptMapping: action.items[key].articleConceptMapping,
                loadingState: LoadingState.SUCCESS,
                errorMessage: null,
                renderBlankInit: false,
            };
        default:
            return state;
    }
};

export interface ConceptTaggingWidgetState {
    [key: string]: ConceptState;
    selectSuggestions: any;
}

export const initialConceptTaggingWidgetState = {
    selectSuggestions: null,
};

declare type ConceptTaggingWidgetReducerAction =
    ConceptsFetchRequestAction
    | ConceptsFetchSuccessAction
    | AddConceptFailureAction
    | AddConceptRequestAction
    | RemoveConceptRequestAction
    | RemoveConceptSuccessAction
    | RemoveConceptFailureAction
    | ConceptsFetchFailureAction
    | UpdateConceptsPositionSuccessAction
    | AddConceptSuccessAction;

export const conceptTaggingWidgetReducer: Reducer<ConceptTaggingWidgetState> =
    (state: ConceptTaggingWidgetState = initialConceptTaggingWidgetState, action: ConceptTaggingWidgetReducerAction) => {
    switch (action.type) {
        case CONCEPTS_FETCH_REQUEST:
        case CONCEPTS_FETCH_FAILURE:
            return {
                ...state,
                ...Object.keys(action.items).reduce((acc, key) => {
                    acc[key] = conceptFetchReducer(state[key], key, action);
                    return acc;
                }, {}),
            };
        case CONCEPTS_FETCH_SUCCESS:
            return {
                ...state,
                ...Object.keys(action.items).reduce((acc, key) => {
                    acc[key] = conceptFetchReducer(state[key], key, action);
                    return acc;
                }, {}),
                selectSuggestions: action.response.result.selectSuggestions,
            };
        case ADD_CONCEPT_SUCCESS:
        case ADD_CONCEPT_FAILURE:
        case ADD_CONCEPT_REQUEST:
        case REMOVE_CONCEPT_REQUEST:
        case REMOVE_CONCEPT_SUCCESS:
        case REMOVE_CONCEPT_FAILURE:
        case UPDATE_CONCEPT_POSITION_SUCCESS:
            return {
                ...state,
                [action.key]: conceptReducer(state[action.key], action),
            };

        default:
            return state;
    }
};

export interface ConceptTaggingWidgetsState {
    [entityType: number]: ConceptTaggingWidgetState;
}

declare type ConceptTaggingWidgetsReducerAction =
    ConceptsFetchRequestAction
    | ConceptsFetchSuccessAction
    | AddConceptFailureAction
    | AddConceptRequestAction
    | RemoveConceptRequestAction
    | RemoveConceptSuccessAction
    | RemoveConceptFailureAction
    | ConceptsFetchFailureAction
    | UpdateConceptsPositionSuccessAction
    | AddConceptSuccessAction;

export const conceptTaggingWidgetsReducer: Reducer<ConceptTaggingWidgetsState> =
    (state: ConceptTaggingWidgetsState = {}, action: ConceptTaggingWidgetsReducerAction) => {
    switch (action.type) {
        case CONCEPTS_FETCH_REQUEST:
        case CONCEPTS_FETCH_FAILURE:
        case CONCEPTS_FETCH_SUCCESS:
        case ADD_CONCEPT_SUCCESS:
        case ADD_CONCEPT_FAILURE:
        case ADD_CONCEPT_REQUEST:
        case REMOVE_CONCEPT_REQUEST:
        case REMOVE_CONCEPT_SUCCESS:
        case REMOVE_CONCEPT_FAILURE:
        case UPDATE_CONCEPT_POSITION_SUCCESS:
            const entityType = action.entityType;
            return tupdate(state, {
                [entityType]: conceptTaggingWidgetReducer(state[entityType], action),
            });

        default:
            return state;
    }
};
